import { Dispatch, SetStateAction } from 'react';
import { toast } from 'react-toastify';
import { logout } from '../../functions/API';
import { LauncherThemeSessionData, UserSessionData } from '../../types/hooks';

export const userLogout = async ({
  setUserSession,
  setLauncherThemeSession,
}: {
  setUserSession: Dispatch<SetStateAction<UserSessionData>>;
  setLauncherThemeSession: Dispatch<SetStateAction<LauncherThemeSessionData>>;
}) => {
  const logoutData = await logout();

  if (!logoutData) {
    toast.error('Something went wrong while logging out', {
      hideProgressBar: true,
      autoClose: 1000,
    });
    return;
  }

  setUserSession({
    isLoggedIn: false,
    isAuthorized: null,
    email: null,
    planName: null,
    paymentModel: null,
  });
  setLauncherThemeSession({
    isThemeLoaded: false,
    themeID: null,
    versionID: null,
    versions: [],
    images: [],
  });
};
